import { forwardRef, type Ref, type SVGProps } from "react";
const IconReloadOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M28.68 19.049a1 1 0 0 0-1.258.643A12.003 12.003 0 1 1 25.748 9H22a1 1 0 1 0 0 2h6a1 1 0 0 0 .986-.836l1-6a1 1 0 0 0-1.972-.328l-.662 3.97a13.997 13.997 0 1 0 1.972 12.502 1 1 0 0 0-.643-1.26"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconReloadOutlineSVG);
ForwardRef.displayName = "IconReloadOutline";
export { ForwardRef as IconReloadOutline };
